import { Form, Modal, Input, Button, Select, Space, InputNumber } from "antd";
import React, { useEffect, useState } from "react";
import { getDirectusClient } from "../../../lib/directus";
import { useForm } from "antd/es/form/Form";
import { createUser, readItems, readRoles, readUsers } from "@directus/sdk";
import { useSelector } from "react-redux";

const { Option } = Select;

function Createseller(props) {
  const [roles, setRoles] = useState([]);
  const [bodegas, setBodegas] = useState([]);
  const [prestamo, setPrestamo] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedBodega, setSelectedBodega] = useState(null);
  const userRoleID = useSelector((state) => state.userdata.role.name);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);

  const [form] = useForm();

  const Roles = async () => {
    const directus = await getDirectusClient();

    directus
      .request(
      readRoles({
        fields: ['id', 'name'],
        filter: {
          name: {
            _nin: ['Administrator', 'adminapp']
          }
        }
      }))
      .then((res) => {
        console.log(res);
        setRoles(res);
      })
      .catch((err) => console.log(err));
  };

  const Bodegas = async () => {
    const directus = await getDirectusClient();

    directus
      .request(
      readItems("bodegas",{
        fields: ['id', 'nombre', ],
        filter:{
          ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
            ? {
                id: { _eq: userBodega },
              }
            : {}),
        }
      }))
      .then((res) => {
        console.log(res);
        setBodegas(res);
      })
      .catch((err) => console.log(err));
  };

  const getUsers = async (bodegaId) => {
    const directus = await getDirectusClient();

    directus
      .request(
        readUsers({
          fields: ["id", "first_name", "last_name", "email", "documento", "role.name", "bodega.id"],
          filter: {
            _and: [
              {
                role: {
                  name: {
                    _neq: 'clientes'
                  }
                }
              },
              {
                bodega: {
                  id: {
                    _eq: bodegaId
                  }
                }
              }
            ]
          }
        })
      )
      .then((res) => {
        setUsers(res);
      })
      .catch((err) => {
        console.error('Error fetching users:', err);
        Modal.error({
          title: 'Error',
          content: 'Error al obtener los usuarios'
        });
      });
  };

  const onFinish = async (values) => {
    const directus = await getDirectusClient();

    directus
      .request(
     createUser(values))
      .then((res) => {
        console.log(res);
        if (res.id) {
          props.closeCreate();
          form.resetFields();
          props.getSellers();
        }
      })
      .catch((err) => console.log(err));
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    Roles();
    Bodegas();
    getUsers();
  }, []);
  return (
    <Modal
      open={props.opencreate}
      onCancel={props.closeCreate}
      title="Crear Producto"
      footer={[
        <Button key="back" onClick={props.closeCreate}>
          cancelar
        </Button>,
      ]}
    >
      <div style={{ margin: 20 }}>
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="nombre"
            name="first_name"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="apellidos"
            name="last_name"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Documento"
            name="documento"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Correo"
            name="email"
            rules={[{ required: true, type: "email" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item name="role" label="Rol" rules={[{ required: true }]}>
            <Select
              placeholder="seleccione un rol"
              allowClear
              onChange={(select) => {
                console.log(select);
                if (select == "7fccd349-4875-4618-b770-344c5cc2e0d8") {
                  setPrestamo(true);
                } else {
                  setPrestamo(false);
                }
              }}
            >
              {roles?.map((rol) => {
                return (
                  <Option key={rol.id} value={rol.id}>
                    {rol.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item name="bodega" label="Bodega" rules={[{ required: true }]}>
            <Select 
              placeholder="seleccione una Bodega" 
              allowClear
              onChange={(value) => {
                setSelectedBodega(value);
                if (value) {
                  getUsers(value);
                } else {
                  setUsers([]);
                }
                // Clear superior selection when bodega changes
                form.setFieldValue('superior', undefined);
              }}
            >
              {bodegas?.map((bodega) => (
                <Option key={bodega.id} value={bodega.id}>{bodega.nombre}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="superior" label="Superior" rules={[{ required: false }]}>
            <Select 
              placeholder="seleccione un Superior" 
              allowClear
              disabled={!selectedBodega}
            >
              {users?.map((user) => (
                <Option key={user.id} value={user.id}>
                  {user.first_name} {user.last_name} 
                  <span style={{fontSize: '12px', color: 'green'}}>
                    {user.role.name}
                  </span>
                </Option>
              ))}
            </Select>
          </Form.Item>

          {prestamo ? (
            <>
              <Form.Item
                label="Tope de prestamo"
                name="tope_de_prestamo"
                rules={[{ required: false }]}
              >
                <InputNumber />
              </Form.Item>
            </>
          ) : null}

          <Form.Item
            label="Contraseña"
            name="password"
            rules={[{ required: false }]}
          >
            <Input />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
}

export default Createseller;
